// Apres la connexion, revenir a la page Bibliotheque ou a une fiche (R11, BIB-E07) : seules ces adresses sont
// acceptees (pas de redirection ouverte vers un autre site ou une autre page)

const LIBRARY_PATH = /^\/bibliotheque(\/[a-z0-9-]{1,80})?(\?[A-Za-z0-9=&%+._-]{0,200})?$/;

/** L'adresse de retour (chemin et recherche), ou null si elle n'est pas une page de la bibliotheque */
export function libraryReturnPath(path: string | null | undefined): string | null {
  return path && LIBRARY_PATH.test(path) ? path : null;
}
